
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-insights/announcements",
      function () {
        return require("private-next-pages/news-and-insights/announcements.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-insights/announcements"])
      });
    }
  